import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from './Common';

// handle the private routes
function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => getToken() != null ? <Component {...props} /> : <Redirect to={{ pathname: '/' }} />}
    />
  )
}

export default PrivateRoute;